module.exports = __webpack_public_path__ + "img/ring_y_0_null_0@3x.dd820108.png";